// PDF reales generados en el momento (Fase 8). Cifras SOLO desde catalogo.json vía el resolver.
import { jsPDF } from 'jspdf';
import { MAX_CUOTAS, planCuotas, fechaCorta } from './cuotas';
import catalogo from '../datos/catalogo.json';
import { getMarcaActiva } from './marcas';
import { productoMvp, ROTULO, fmtPesos } from './perfil';

const PROD = { A: 'MKT-003', B: 'MKT-023', C: 'MKT-011' };
const byId = (id) => {
  const p = catalogo.productos.find((x) => x.id === id) || {};
  return p.prima_origen === 'rango del ramo' ? { ...p, prima_origen: 'rango típico del mercado' } : p;
};
const hoy = () => new Date().toLocaleDateString('es-CO');

const head = (doc, titulo) => {
  const marca = getMarcaActiva();
  doc.setFillColor(29, 29, 29);
  doc.rect(0, 0, 210, 22, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.text(marca.nombre, 14, 14);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(11);
  doc.text(titulo, 14 + doc.getTextWidth(marca.nombre) + 6, 14);
  doc.setTextColor(29, 29, 29);
  doc.setFontSize(8);
  doc.text('Resumen para revisar con tu asesor (ejemplo) · datos ficticios · no constituye póliza real', 14, 28);
};

const foot = (doc) => {
  doc.setFontSize(8);
  doc.setTextColor(120, 120, 120);
  doc.text(`Fuente: catálogo de referencia · generado ${hoy()}`, 14, 285);
};

const lines = (doc, arr, x, y0, lh = 7) => {
  let y = y0;
  arr.forEach(([label, val]) => {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(9);
    doc.text(String(label), x, y);
    doc.setFont('helvetica', 'normal');
    const wrapped = doc.splitTextToSize(String(val), 130);
    doc.text(wrapped, x + 52, y);
    y += lh * Math.max(1, wrapped.length);
  });
  return y;
};

const pesos = (n) => (typeof n === 'number' ? `$${n.toLocaleString('es-CO')}/mes` : 'ND');

// Caso A: estructura de la carátula de La Equidad (cotización real de ejemplo). Cliente ficticio.
function pdfPolizaA(lead) {
  const p = productoMvp('eq-auto');
  const pf = (lead && lead.perfil && lead.perfil.autos) || null;
  const resp = pf ? Object.fromEntries(pf.respuestas) : {};
  const doc = new jsPDF();
  head(doc, 'Resumen de póliza');
  doc.setFontSize(15);
  doc.setFont('helvetica', 'bold');
  doc.text(`${p.aseguradora} · ${p.plan}`, 14, 40);
  const ini = new Date();
  const fin = new Date(ini); fin.setFullYear(fin.getFullYear() + 1);
  const f = (d) => d.toLocaleDateString('es-CO');
  const seccion = (t, y) => { doc.setFont('helvetica', 'bold'); doc.setFontSize(10.5); doc.text(t, 14, y); return y + 6; };
  let y = seccion('Tomador y asegurado', 50);
  y = lines(doc, [['Nombre', 'Cliente de ejemplo'], ['Vigencia', `Desde ${f(ini)} hasta ${f(fin)} (12 meses)`]], 14, y, 5.5);
  y = seccion('Descripción del riesgo', y + 3);
  const r = p.riesgo_ejemplo;
  y = lines(doc, [
    ['Marca y línea', `${r.vehiculo} (cotización de ejemplo)`],
    ['Modelo', r.modelo],
    ['Ciudad de circulación', r.ciudad],
    ['Valor comercial', r.valor_comercial],
    ['Accesorios', resp.Accesorios || 'No declarados'],
  ], 14, y, 5.5);
  y = seccion('Coberturas', y + 3);
  doc.setFontSize(8.5);
  doc.setFillColor(29, 29, 29); doc.rect(14, y - 4, 182, 6.5, 'F');
  doc.setTextColor(255, 255, 255);
  doc.text('Cobertura', 16, y); doc.text('Valor asegurado', 112, y); doc.text('Deducible', 160, y);
  doc.setTextColor(29, 29, 29); doc.setFont('helvetica', 'normal');
  y += 6.5;
  p.coberturas.forEach((c, i) => {
    if (i % 2 === 1) { doc.setFillColor(244, 244, 244); doc.rect(14, y - 4, 182, 6, 'F'); }
    doc.text(doc.splitTextToSize(c.nombre, 92)[0], 16, y);
    doc.text(c.valor, 112, y);
    doc.text(c.deducible || '—', 160, y);
    y += 6;
  });
  y = seccion('Asistencias incluidas', y + 4);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
  const as = doc.splitTextToSize(p.asistencias.join(' · '), 180);
  doc.text(as, 14, y); y += as.length * 5 + 3;
  y = seccion('Prima anual', y);
  y = lines(doc, [
    ['Prima neta', fmtPesos(p.prima.neta)],
    ['Gastos', fmtPesos(p.prima.gastos)],
    ['IVA', fmtPesos(p.prima.iva)],
    ['Total', fmtPesos(p.prima.valor)],
    ['Plazo para pagar', '30 días desde el inicio de la vigencia; si no se paga, la póliza se cancela.'],
  ], 14, y, 5.5);
  doc.setFontSize(8); doc.setTextColor(180, 83, 9);
  doc.text(`${ROTULO}.`, 14, y + 4);
  doc.setTextColor(29, 29, 29);
  foot(doc);
  doc.save(`poliza-A-${Date.now()}.pdf`);
}

export function pdfPoliza(caseId, lead) {
  if (caseId === 'A') return pdfPolizaA(lead);
  const id = PROD[caseId] || 'MKT-003';
  const p = byId(id);
  const doc = new jsPDF();
  head(doc, 'Resumen de póliza');
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text(p.producto || 'Producto', 14, 42);
  const prima = p.prima_min === p.prima_max ? pesos(p.prima_min) : `${pesos(p.prima_min)} a ${pesos(p.prima_max)}`;
  lines(doc, [
    ['Asegurado', lead?.nombre || '—'],
    ['Contacto', lead?.tel || '—'],
    ['Categoría', p.categoria || '—'],
    ['Prima', `${prima} (${p.prima_origen || 'ND'})`],
    ['Deducible', p.deducible || 'ND'],
    ['Coberturas', p.coberturas_clave || 'ND'],
    ['Exclusiones', p.exclusiones_principales || 'ND'],
    ['Vigencia', 'Anual, renovable · sujeta a condiciones generales'],
  ], 14, 54);
  foot(doc, id);
  doc.save(`mbm-poliza-${caseId}-${Date.now()}.pdf`);
}

export function pdfCondiciones(caseId) {
  const id = PROD[caseId] || 'MKT-003';
  const p = byId(id);
  const doc = new jsPDF();
  head(doc, 'Condiciones generales');
  doc.setFontSize(13);
  doc.setFont('helvetica', 'bold');
  doc.text('Lo que la póliza cubre y lo que no', 14, 42);
  let y = 54;
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('Coberturas clave', 14, y); y += 7;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.text(doc.splitTextToSize(p.coberturas_clave || 'ND', 180), 14, y);
  y += 7 * (doc.splitTextToSize(p.coberturas_clave || 'ND', 180).length) + 6;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.text('Exclusiones principales', 14, y); y += 7;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.text(doc.splitTextToSize(p.exclusiones_principales || 'ND', 180), 14, y);
  y += 7 * (doc.splitTextToSize(p.exclusiones_principales || 'ND', 180).length) + 6;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.text('Deducible', 14, y); y += 7;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.text(doc.splitTextToSize(p.deducible || 'ND', 180), 14, y);
  foot(doc, id);
  doc.save(`mbm-condiciones-${caseId}-${Date.now()}.pdf`);
}

export function pdfPlanPagos(caseId, plan, cuotas = MAX_CUOTAS) {
  const id = PROD[caseId] || 'MKT-003';
  const p = byId(id);
  const eq = caseId === 'A' ? productoMvp('eq-auto') : null;
  const mensual = p.prima_min || 0;
  const anual = eq ? eq.prima.valor : mensual * 12;
  const pesosPlano = (n) => `$${(n || 0).toLocaleString('es-CO')}`;
  const contado = plan === 'contado';
  const cuotasPlan = planCuotas(anual, contado ? 1 : cuotas);
  const n = cuotasPlan.length;
  const nTxt = n === 1 ? '1 cuota' : `${n} cuotas`;
  const doc = new jsPDF();
  head(doc, 'Plan de pagos (ejemplo)');
  doc.setFontSize(13);
  doc.setFont('helvetica', 'bold');
  doc.text(`${eq ? `${eq.aseguradora} · ${eq.plan}` : p.producto || 'Producto'} · ${contado ? 'Contado' : nTxt}`, 14, 42);
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  const desglose = eq ? ` (neta ${pesosPlano(eq.prima.neta)} + gastos ${pesosPlano(eq.prima.gastos)} + IVA ${pesosPlano(eq.prima.iva)})` : ` (${p.prima_origen || 'por confirmar'})`;
  doc.text(doc.splitTextToSize(contado
    ? `Prima total anual: ${pesosPlano(anual)}${desglose}. Pago único por la pasarela.`
    : `Prima total anual: ${pesosPlano(anual)}${desglose}, en ${nTxt} financiadas por la aseguradora, sin intereses de financiación (si los hay, los confirma el asesor).`, 182), 14, 50);
  let y = 64;
  doc.setFont('helvetica', 'bold');
  doc.text('Cuota', 14, y);
  doc.text('Fecha de vencimiento', 50, y);
  doc.text('Valor', 150, y);
  doc.setDrawColor(200);
  doc.line(14, y + 2, 196, y + 2);
  y += 8;
  doc.setFont('helvetica', 'normal');
  cuotasPlan.forEach((c) => {
    doc.text(contado ? 'Pago único' : `${c.i} de ${c.n}`, 14, y);
    doc.text(contado ? `${fechaCorta(new Date())} (al pagar)` : fechaCorta(c.vence), 50, y);
    doc.text(pesosPlano(c.valor), 150, y);
    y += 6;
    if (y > 270) { doc.addPage(); y = 20; }
  });
  doc.setFont('helvetica', 'bold');
  doc.line(14, y - 3, 196, y - 3);
  doc.text('Total', 14, y + 2);
  doc.text(pesosPlano(anual), 150, y + 2);
  doc.setFont('helvetica', 'normal');
  y += 12;
  doc.text('Plazo para pagar: 30 días desde el inicio de la vigencia; si una cuota no se paga, la póliza se puede cancelar.', 14, y);
  if (eq) {
    doc.setFontSize(8); doc.setTextColor(180, 83, 9);
    doc.text(`${ROTULO}.`, 14, y + 8);
    foot(doc);
    doc.save(`plan-pagos-A-${Date.now()}.pdf`);
    return;
  }
  foot(doc, id);
  doc.save(`mbm-plan-pagos-${caseId}-${Date.now()}.pdf`);
}

export const primaCaso = (caseId) => {
  const p = byId(PROD[caseId] || 'MKT-003');
  if (caseId === 'A') {
    const eq = productoMvp('eq-auto');
    return { id: eq.id, nombre: `${eq.aseguradora} · ${eq.plan}`, min: null, max: null, anual: eq.prima.valor, origen: ROTULO };
  }
  return { id: PROD[caseId] || 'MKT-003', nombre: p.producto, min: p.prima_min, max: p.prima_max, origen: p.prima_origen };
};

// Ficha para la llamada · marca de la entidad (B2B2C). "Con tecnología de MBM" en el pie.
const hexRgb = (hex) => {
  const h = String(hex || '#1D1D1D').replace('#', '');
  return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)];
};

export function pdfFichaLlamada(lead, marca, resultado) {
  const [r, g, b] = hexRgb(marca.color);
  const doc = new jsPDF();
  doc.setFillColor(r, g, b);
  doc.rect(0, 0, 210, 24, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(13);
  doc.text(marca.nombre, 14, 15);
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.text('Ficha para la llamada', 14, 21);

  doc.setTextColor(29, 29, 29);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.text(lead.nombre || 'Cliente', 14, 38);

  let y = lines(doc, [
    ['Necesidad', lead.necesidad || '—'],
    ['WhatsApp', lead.whatsapp || '—'],
    ['Consentimiento', lead.consent ? 'Sí' : 'No'],
    ['Interés', (lead.productos || []).join(', ') || '—'],
  ], 14, 48);

  if (lead.entendido && lead.entendido.length) {
    doc.setFont('helvetica', 'bold'); doc.setFontSize(10);
    doc.text('Ya entendió', 14, y + 6);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
    doc.text(doc.splitTextToSize(lead.entendido.join(' · '), 180), 14, y + 12);
    y += 20;
  }

  Object.values(lead.perfil || {}).forEach((pf) => {
    doc.setFont('helvetica', 'bold'); doc.setFontSize(10);
    doc.text(`Perfil del caso · ${pf.ramo}`, 14, y + 6);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
    const filas = [
      ...pf.respuestas.map(([l, v]) => `${l}: ${v}`),
      ...(pf.eleccion ? [`Eligió en el comparador: ${pf.eleccion}`] : []),
      ...((pf.opciones || []).length ? [`Las otras que comparó: ${pf.opciones.filter((n) => n !== pf.eleccion).join('; ')}`] : []),
      ...(pf.escalado ? [`Pasa al asesor: ${pf.escalado}`] : []),
    ];
    const w = doc.splitTextToSize(filas.join(' · '), 180);
    doc.text(w, 14, y + 12);
    y += 12 + w.length * 4.5;
  });

  const opts = (resultado && resultado.comp) || [];
  if (opts.length) {
    doc.setFont('helvetica', 'bold'); doc.setFontSize(10);
    doc.text('Opciones comparadas (solo datos del catálogo)', 14, y + 6);
    y += 11;
    // Tabla visual: cabecera con color de la entidad + filas alternas.
    const cols = [
      { k: 'nombre', w: 66, h: 'Producto' },
      { k: 'prima', w: 42, h: 'Prima' },
      { k: 'deducible', w: 46, h: 'Deducible' },
      { k: 'edad', w: 28, h: 'Edad máx' },
    ];
    const x0 = 14;
    doc.setFillColor(r, g, b);
    doc.rect(x0, y, 182, 8, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont('helvetica', 'bold'); doc.setFontSize(8);
    let cx = x0 + 2;
    cols.forEach((c) => { doc.text(c.h, cx, y + 5.4); cx += c.w; });
    y += 8;
    doc.setTextColor(40, 40, 40);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(8);
    opts.forEach((o, i) => {
      const cells = cols.map((c) => doc.splitTextToSize(String(o[c.k] || 'ND'), c.w - 3));
      const rowH = Math.max(...cells.map((w) => w.length)) * 4 + 4;
      if (i % 2 === 1) { doc.setFillColor(244, 244, 244); doc.rect(x0, y, 182, rowH, 'F'); }
      let ccx = x0 + 2;
      cells.forEach((w, ci) => {
        if (ci === 0) doc.setFont('helvetica', 'bold'); else doc.setFont('helvetica', 'normal');
        doc.text(w, ccx, y + 4.5);
        ccx += cols[ci].w;
      });
      doc.setDrawColor(226, 226, 226);
      doc.line(x0, y + rowH, x0 + 182, y + rowH);
      y += rowH;
    });
    y += 2;
  }

  const preguntas = (resultado && resultado.ficha && resultado.ficha.preguntas) || [];
  if (preguntas.length) {
    doc.setFont('helvetica', 'bold'); doc.setFontSize(10);
    doc.text('Preguntas sugeridas', 14, y + 6);
    doc.setFont('helvetica', 'normal'); doc.setFontSize(9);
    preguntas.forEach((q, i) => { doc.text(doc.splitTextToSize(`${i + 1}. ${q}`, 180), 14, y + 12 + i * 6); });
    y += 12 + preguntas.length * 6;
  }

  doc.setTextColor(r, g, b);
  doc.setFont('helvetica', 'bold'); doc.setFontSize(9);
  doc.text('La decisión y la recomendación son del corredor humano.', 14, Math.min(y + 8, 270));

  doc.setTextColor(120, 120, 120);
  doc.setFont('helvetica', 'normal'); doc.setFontSize(8);
  doc.text(`Ficha de demostración · datos ficticios · Con tecnología de MBM · ${hoy()}`, 14, 288);
  doc.save(`ficha-${(lead.nombre || 'lead').replace(/\s+/g, '-').toLowerCase()}-${Date.now()}.pdf`);
}
